import { render, staticRenderFns } from "./List.vue?vue&type=template&id=415e0962&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "@/sass/06_atoms/list.scss?vue&type=style&index=0&id=415e0962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415e0962",
  null
  
)

export default component.exports